import CounterChartRepository from '@src/repositories/CounterChartRepository';

class CounterChartService {
  constructor() {
    this.counterChartRepository = new CounterChartRepository();
  }

  async createCounterChart({ data, orgId, divId = null, boardId }) {
    return this.counterChartRepository.create({ data, orgId, divId, boardId });
  }

  async updateCounterChart({ data, orgId, divId = null, boardId, chartId }) {
    return this.counterChartRepository.update({ data, orgId, divId, boardId, chartId });
  }

  async getCounterChart({ orgId, divId = null, boardId, chartId }) {
    return this.counterChartRepository.get({ orgId, divId, boardId, chartId });
  }
}

export default CounterChartService;
